import { createAction, props } from '@ngrx/store';
import { PaceOfflineFeatureState } from '../state';

export const hydrate = createAction('[PaceOffline] Hydrate');

export const hydrateSuccess = createAction(
    '[PaceOffline] Hydrate Success',
    props<{ state: PaceOfflineFeatureState }>(),
);

export const hydrateFailure = createAction('[PaceOffline] Hydrate Failure');

export const deleteCache = createAction('[PaceOffline] Delete Cache');

export const resetStore = createAction('[Pace Offline] reset offline state');
